export const PULL_LOGS_ERROR = 'PULL_LOGS_ERROR';
export const PULL_LOGS_REQUEST = 'PULL_LOGS_REQUEST';
export const PULL_LOGS_SUCCESS = 'PULL_LOGS_SUCCESS';
export const PULL_LOGS_RESET = 'PULL_LOGS_RESET';
